let templateString = require('./device-admin-actions.component.html');

class skAdminActionController {
  constructor(
    DevicesService,
    ProgressBarService,
    SessionsService,
    ToastsService
  ) {
    'ngInject';
    this.DevicesService = DevicesService;
    this.ProgressBarService = ProgressBarService;
    this.SessionsService = SessionsService;
    this.ToastsService = ToastsService;
  }

  showRefreshViaCdm() {
    let tenantId = null;
    if(this.device && this.device.tenant) {
      tenantId = this.device.tenant.id    
    }
    let managingOrgId = this.DevicesService.getManagingOrgId(this.device);
    
    if (this.SessionsService.getIsAdmin() && this.DevicesService.isManagedDevice(this.device)) {
      return true;
    } 
    else if (this.SessionsService.isManagingOrgAdmin(managingOrgId)) {
      return true;
    }
    else if(this.SessionsService.isTenantAdmin(tenantId)) {
      return true;
    } 
    else {
      return false;
    }
  }

  showCards() {
    return (
      this.showRefreshViaCdm()
      || this.showSyncToContentManager()
    );
  }

  refreshViaCdm() {
    return this.ToastsService.wrap(
      this.ProgressBarService.wrap(
        this.DevicesService.refreshViaCdm(this.device)
      ),
      'CDM device refresh has been queued',
      'Error queueing CDM device refresh',
    );
  }

  showSyncToContentManager() {
    if (this.SessionsService.getIsAdmin()) {
      return true;
    }
    let managingOrgId = this.DevicesService.getManagingOrgId(this.device);
    return this.SessionsService.isManagingOrgAdmin(managingOrgId);
  }

  syncToContentManager() {
    return this.ToastsService.wrap(
      this.ProgressBarService.wrap(
        this.DevicesService.syncToContentManager(this.device)
      ),
      'Device synced to CMS',
      'Error syncing device to CMS'
    );
  }
}

export let deviceAdminActions = {
  template: templateString,
  bindings: {
    isSuccess: '<',
    device: '<'
  },
  controller: skAdminActionController
};

angular.module('skykitProvisioning')
.component('deviceAdminActions', deviceAdminActions)
.controller('skAdminActionController', skAdminActionController)
